import { useT } from "@transifex/react";
import { DownloadSimpleIcon } from "@phosphor-icons/react";
import BasePopupWrapper, { TitleColorVariants } from "../../basic/popups/BasePopupWrapper";
import { AreaButton, ButtonColorVariant, ButtonVariant, IconPosition } from "../teacherArea/AreaButton";
import useBreakpoints, { Breakpoint } from "../../hooks/useBreakpoints";
import { ORANGE_OUTLINE_BUTTON_CLASS, PILL_BUTTON_CLASS } from "./styleConstants";

interface DownloadFormatPopupProps {
    isOpen: boolean;
    onClose: () => void;
    onDownloadXlsx: () => void;
    onDownloadCsv: () => void;
}

const DownloadFormatPopup = (props: DownloadFormatPopupProps) => {
    const t = useT();
    const { getStyleBasedOnBreakpoint } = useBreakpoints();

    const t_title = t("Download results as table", {
        _tags: "ShareTestReviews, DownloadFormatPopup",
    });
    const t_downloadXlsx = t("Download XLSX", {
        _tags: "ShareTestReviews, DownloadFormatPopup",
    });
    const t_downloadCsv = t("Download CSV", {
        _tags: "ShareTestReviews, DownloadFormatPopup",
    });
    const t_close = t("Close", { _tags: "ShareTestReviews, DownloadFormatPopup" });

    const buttonsRowClass = `flex gap-s w-full ${getStyleBasedOnBreakpoint(
        Breakpoint.SM,
        "flex-row [&>*]:flex-1",
        "flex-col [&>*]:w-full"
    )}`;

    return (
        <BasePopupWrapper
            isOpen={props.isOpen}
            onClose={props.onClose}
            title={t_title}
            titleColor={TitleColorVariants.DEFAULT}
            secondaryButton={{
                text: t_close,
                onClick: props.onClose,
                colorVariant: ButtonColorVariant.DEFAULT,
                className: `${PILL_BUTTON_CLASS} min-w-[200px]`,
            }}
        >
            <div className={buttonsRowClass}>
                <AreaButton
                    variant={ButtonVariant.SECONDARY}
                    role="button"
                    onClick={props.onDownloadXlsx}
                    phosphorIcon={DownloadSimpleIcon}
                    iconPosition={IconPosition.RIGHT}
                    className={ORANGE_OUTLINE_BUTTON_CLASS}
                >
                    {t_downloadXlsx}
                </AreaButton>
                <AreaButton
                    variant={ButtonVariant.PRIMARY}
                    role="button"
                    onClick={props.onDownloadCsv}
                    phosphorIcon={DownloadSimpleIcon}
                    iconPosition={IconPosition.RIGHT}
                    className={PILL_BUTTON_CLASS}
                >
                    {t_downloadCsv}
                </AreaButton>
            </div>
        </BasePopupWrapper>
    );
};

export default DownloadFormatPopup;
